import api from "./api";

const IntegracoesService = {
    subscribeFacebookPages: (code) => {
        return api.get(`/integracoes/facebook/pages?oauth_code=${code}`)
    }
}

export default IntegracoesService;
